import React, { useEffect, useState } from 'react'
import TextArea from '../../components/form/TextArea/TextArea'
import { Form, Spinner } from 'react-bootstrap'
import '../../components/kyc/kycStyle.css'
import {
  validateCompanyRegistrationNumber,
  validateIdNumber,
  validateKimNumber,
  validateVATNumber,
} from '../../utils/Validation'
import ScreenHeader from '../../components/kyc/ScreenHeader'
import {
  DETAILED_BUSINESS_REPORT_OPTIONS,
  INVALID_ID_WARNING,
  INVALID_KIM_WARNING,
  DISCLAIMER,
  INVALID_REG_NUMBER_WARNING,
  NCA_TEXT,
  CMAINFO_DISCLAIMER,
  DOWNLOAD_TEXT,
  INVALID_VAT_WARNING,
  PRICELIST,
} from '../../utils/Constants'
import SearchBySelect from '../../components/form/SearchBySelect/SearchBySelect'
import FormInput from '../../components/form/FormInput/FormInput'
import Checkbox from '../../components/form/Checkbox/Checkbox'
import Alert from '../../components/form/Alerts/BasicAlert'
import FooterButtons from '../../components/form/FooterButtons/FooterButtons'
import NewAndCloseButtons from '../../components/form/NewAndCloseButtons/NewAndCloseButtons'
import {
  // downloadReport,
  handleXpertBusinessLoadReport,
  handleXpertBusinessSearchCompany,
} from '../../api/businessEnquiry/businessEnquiry'
import SearchResultTable from '../../components/kyc/SearchResultTable'
import { ReportResponseForm } from '../../components/kyc/ReportResponseForm'
import KycButton from '../../components/form/Button/Button'
import { ProductIds, ReportTypes } from '../../api/apiConstants'
import { RESTRICTED_REPORT } from '../../utils/Constants'
import './DetailedBusinessReport.css'
import ScreenLayout from '../../components/layouts/ScreenLayout'
import { useDownloadFile } from '../../hooks/use-download-file'
type Props = {
  setShow: (value: boolean) => void
  initialState: { [key: string]: any }
  setInitialState: React.Dispatch<React.SetStateAction<any>>
  setIsError: (value: boolean) => void
  setErrorMessage: (value: string) => void
  KYCAccess: boolean
}
interface HandleXpertBusinessSearchCompanyProps {
  companyRegistrationNumber: string
  companyName: string
  companyVATNumber?: string
  companySoleProprietorId?: string
  searchParam: string
  setXpertBusinesses: any
  setShowProgress: React.Dispatch<React.SetStateAction<boolean>>
  setIsError: (isError: boolean) => void
  setErrorMessage: (errorMessage: string) => void
  kimNumber?: string
  purpose: string
}
interface Business {
  enquiryId: string
  enquiryResultId: string
  registrationNo: string
}
const DetailedBusinessReport = ({
  setShow,
  initialState,
  setInitialState,
  setIsError,
  setErrorMessage,
  KYCAccess,
}: Props) => {
  const [searchBySelectedOption, setSearchBySelectedOption] =
    useState<string>('')
  const [showProgress, setShowProgress] = useState(false)
  const [registrationNumber, setRegistrationNumber] = useState<string>('')
  const [xpertBusinesses, setXpertBusinesses] = useState([])
  const [vatNumber, setVatNumber] = useState('')
  const [companyName, setCompanyName] = useState('')
  const [idNumber, setIdNumber] = useState<string>('')
  const [reference, setReference] = useState<string>('')
  const [showDownloadReport, setShowDownloadReport] = useState(false)
  const [isFirstBoxChecked, setIsFirstBoxChecked] = useState(false)
  const [isSecondBoxChecked, setIsSecondBoxChecked] = useState(false)
  const [reportId, setReportId] = useState(0)
  const searchParams = {
    REG_NR: registrationNumber,
    ID_NR: idNumber,
    VAT_NR: vatNumber,
    COMP_NAME: companyName,
  }
  const handleFirstBoxChange = () => {
    if (!isFirstBoxChecked) {
      setIsFirstBoxChecked(true)
      setIsSecondBoxChecked(false)
    }
  }

  const handleSecondBoxChange = () => {
    if (!isSecondBoxChecked) {
      setIsSecondBoxChecked(true)
      setIsFirstBoxChecked(false)
    }
  }

  const [searchParam, setSearchParam] =
    useState<keyof typeof searchParams>('REG_NR')
  const priceAddition = 3.6
  const handleStartOver = () => {
    // Might need to refactor this code.
    setSearchParam('REG_NR')
    setRegistrationNumber('')
    setIdNumber('')
    setSearchBySelectedOption('')
    setCompanyName('')
    setShowDownloadReport(false)
    setXpertBusinesses([])
    setReference('')
    setIsFirstBoxChecked(false)
    setIsSecondBoxChecked(false)
  }
  const validateFields = (
    handleMissing?: (missingFields: string[]) => void,
  ) => {
    let isValid = true
    const missingFields = []
    if (searchParam === 'COMP_NAME') {
      if (!companyName) {
        missingFields.push('Company Name')
        isValid = false
      }
    } else if (searchParam === 'VAT_NR') {
      isValid = validateVATNumber(vatNumber)
      if (!vatNumber) missingFields.push('VAT Number')
    } else if (searchParam === 'REG_NR') {
      isValid = validateCompanyRegistrationNumber(registrationNumber!)
      if (!registrationNumber) missingFields.push('Registration Number')
    } else if (searchParam === 'ID_NR') {
      isValid = validateIdNumber(idNumber!)
      if (!idNumber) missingFields.push('ID Number')
    }
    if (searchBySelectedOption === '') {
      isValid = false
      missingFields.push('Prescribed Purpose')
    }
    if (!isFirstBoxChecked && !isSecondBoxChecked) {
      isValid = false
      missingFields.push(
        'Select either Juristic Entity Or Terms and Conditions',
      )
    }
    if (handleMissing) handleMissing(missingFields)
    if (isValid && (isFirstBoxChecked || isSecondBoxChecked)) {
      return true
    } else {
      return false
    }
  }
  // useEffect(() => {
  //   validateFields()
  // }, [
  //   idNumber,
  //   kimNumber,
  //   registrationNumber,
  //   searchParam,
  //   isFirstBoxChecked,
  //   isSecondBoxChecked,
  // ])
  const updateInitialState = () => {
    setInitialState({
      ...initialState,
      detailedBusinessReport: {
        cipcSearchParam: searchParam,
        searchBySelectedOption: searchBySelectedOption,
        registrationNumber: registrationNumber,
        companyName: companyName,
        idNumber: idNumber,
        reference: reference,
      },
    })
  }
  const handleSearch = () => {
    const isValid = validateFields((missingFields) => {
      if (missingFields.length > 0)
        alert(`Please enter ${missingFields.join(', ')}`)
    })
    const trimmedRegistrationNumber = registrationNumber.replace(/\s/g, '')
    if (!isValid) return
    updateInitialState()
    const params: HandleXpertBusinessSearchCompanyProps = {
      companyRegistrationNumber: trimmedRegistrationNumber,
      companyName: companyName,
      companySoleProprietorId: idNumber,
      searchParam,
      setShowProgress,
      setIsError,
      setErrorMessage,
      setXpertBusinesses,
      purpose: searchBySelectedOption,
      companyVATNumber: vatNumber,
    }
    handleXpertBusinessSearchCompany(
      params as HandleXpertBusinessSearchCompanyProps,
    )
  }
  const handleDownload = (business: Business) => {
    const params = {
      setShowProgress,
      setIsError,
      setErrorMessage,
      business,
      reference,
      setReportId,
      setShowDownloadReport,
      reportTypeId: ReportTypes.DetailedBusinessReport.reportTypeId,
      productId: ProductIds.DetailedBusinessReport.productId,
      purpose: searchBySelectedOption,
      isFirstBoxChecked: isFirstBoxChecked,
      isSecondBoxChecked: isSecondBoxChecked,
      downloadReport,
    }
    handleXpertBusinessLoadReport(params)
  }

  const { mutate: downloadReport, isLoading: isDownloading } = useDownloadFile(
    '/BusinessEnquiry/download-report',
    reportId + '',
    ReportTypes.DetailedBusinessReport.reportTypeId,
    setIsError,
    setErrorMessage,
  )
  const handleDownloadCipcReport = () => {
    const params = {
      reportId,
      setShowProgress,
      setIsError,
      setErrorMessage,
      reportTypeId: ReportTypes.DetailedBusinessReport.reportTypeId,
    }
    // downloadReport(params)
    downloadReport(reportId + '')
  }
  return (
    <ScreenLayout
      price={PRICELIST.DETAILED_BUSINESS_REPORT}
      headerText="Detailed Business Report"
      subHeaderText="A Business Profile providing a comprehensive credit-related overview of an organization"
      sampleReport={'DetailedBusinessReport.pdf'}
    >
      {showProgress && (
        <>
          <div className="spinner-container">
            <Spinner
              as="span"
              animation="border"
              variant="dark"
              role="status"
              aria-hidden="true"
            ></Spinner>
            <span> </span>
          </div>
        </>
      )}
      {Object.keys(xpertBusinesses).length === 0 ? (
        <>
          <div className="mb-3">
            {KYCAccess !== true && (
              <p className="lbl-red">{RESTRICTED_REPORT}</p>
            )}
            <SearchBySelect
              className="dropdown-down"
              options={DETAILED_BUSINESS_REPORT_OPTIONS.searchBy}
              onChangeHandler={(value: string) => {
                setRegistrationNumber('')
                setIdNumber('')
                setCompanyName('')
                setVatNumber('')
                setSearchParam(value as keyof typeof searchParams)
              }}
            />
          </div>
          {searchParam === 'REG_NR' && (
            <>
              <FormInput
                className="mb-3"
                required
                placeHolderText="Registration number"
                onChangeHandler={setRegistrationNumber}
                value={registrationNumber}
              />
              {registrationNumber &&
                !validateCompanyRegistrationNumber(registrationNumber) && (
                  <Alert variant="danger" text={INVALID_REG_NUMBER_WARNING} />
                )}
            </>
          )}
          {searchParam === 'COMP_NAME' && (
            <>
              <FormInput
                className="mb-3"
                onChangeHandler={setCompanyName}
                required
                placeHolderText="Company name"
                value={companyName}
              />
            </>
          )}
          {searchParam === 'ID_NR' && (
            <>
              <FormInput
                className="mb-3"
                onChangeHandler={setIdNumber}
                required
                placeHolderText="ID number"
                value={idNumber}
              />
              {idNumber && !validateIdNumber(idNumber) && (
                <Alert variant="danger" text={INVALID_ID_WARNING} />
              )}
            </>
          )}
          {searchParam === 'VAT_NR' && (
            <>
              <FormInput
                className="mb-3"
                onChangeHandler={setVatNumber}
                required
                placeHolderText="VAT number"
                value={vatNumber}
              />
              {vatNumber && !validateVATNumber(vatNumber) && (
                <Alert variant="danger" text={INVALID_VAT_WARNING} />
              )}
            </>
          )}
          <SearchBySelect
            className="mb-3"
            onChangeHandler={setSearchBySelectedOption}
            options={DETAILED_BUSINESS_REPORT_OPTIONS.PrescribedPurpose}
            required
          />
          <FormInput
            className="mb-3"
            onChangeHandler={setReference}
            placeHolderText="Search reference (optional)"
            controlId="formReference"
            value={reference}
          />
          <Form.Group className="checkbox-input">
            <Form.Check
              className="checkbox-input"
              type="checkbox"
              checked={isFirstBoxChecked}
              onChange={handleFirstBoxChange}
              style={{ paddingTop: '15px' }}
            />
            <label
              style={{
                marginLeft: '10px',
                paddingBottom: '10px',
                fontSize: '11px',
              }}
            >
              This juristic entity has an annual turnover in excess of R1
              million <br />
              and therefore does not require consent as noted in Section 4(1)(a){' '}
              <br />
              of the National Credit Act, No. 34 of 2005.
            </label>
          </Form.Group>
          <Form.Group className="checkbox-input">
            <Form.Check
              type="checkbox"
              checked={isSecondBoxChecked}
              onChange={handleSecondBoxChange}
              style={{ paddingTop: '15px' }}
            />
            <label
              style={{
                marginLeft: '10px',
                paddingBottom: '5px',
                fontSize: '11px',
              }}
            >
              By selecting this checkbox, I confirm that consent has been <br />
              received from the individual, of which evidence must be made{' '}
              <br />
              available in the event of an audit.
            </label>
          </Form.Group>
          <span className="legalText">{NCA_TEXT}</span>
          <span className="belowLegal">{DOWNLOAD_TEXT}</span>
          {!showDownloadReport && (
            <FooterButtons
              setShow={setShow}
              isDisabled={!KYCAccess}
              handleSearch={handleSearch}
              isLoading={showProgress}
            />
          )}
          <TextArea className="disclaimer" Text={DISCLAIMER} />
          <span className="cmaDisclaimerDBR">{CMAINFO_DISCLAIMER}</span>
        </>
      ) : (
        <>
          <div style={{ overflow: 'auto' }}>
            <SearchResultTable
              showProgress={showProgress}
              xpertBusinesses={xpertBusinesses}
              handleXpertBusinessLoadReport={(business) =>
                handleDownload(business)
              }
            />
          </div>
          <NewAndCloseButtons
            handleAction={handleStartOver}
            handleClose={setShow}
          />
        </>
      )}
    </ScreenLayout>
  )
}
export default DetailedBusinessReport
